var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-mt-6 sm:-mt-5 px-4 py-4 sm:py-6 sm:px-6 lg:px-8"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }